import { render } from "./ProjectDueDate.vue?vue&type=template&id=56883947"
import script from "./ProjectDueDate.vue?vue&type=script&lang=js"
export * from "./ProjectDueDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__